var map = {
	"./amber.png": "3881",
	"./blue.png": "0eaa",
	"./blueGrey.png": "1309",
	"./brown.png": "dbca",
	"./cyan.png": "dbbc",
	"./deepOrange.png": "15f7",
	"./deepPurple.png": "7dc8",
	"./green.png": "6b42",
	"./grey.png": "c012",
	"./lightBlue.png": "b83c",
	"./lightGreen.png": "aa4b",
	"./lime.png": "dc5a",
	"./orange.png": "5ff3",
	"./pink.png": "7b99",
	"./primary.png": "c40c",
	"./purple.png": "6312",
	"./red.png": "a3d7",
	"./teal.png": "452c",
	"./yellow.png": "dab0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ee6";